import Reveal from "../common/reveal";
import { SPEAKING, SPEAKING_PULL } from "../../data/speaking";

const Teaching = () => (
	<Reveal as="section" className="wrap sec sec-end">
		<div
			className="secnum"
			style={{ marginBottom: "clamp(28px, 4vw, 48px)" }}
		>
			05 · Teaching and speaking
		</div>
		<div className="split">
			<div style={{ flex: "1 1 380px", minWidth: 0 }}>
				<p className="pull-sm">{SPEAKING_PULL}</p>
			</div>
			<div style={{ flex: "1 1 420px", minWidth: 0 }}>
				{SPEAKING.map((entry, index) => (
					<div
						key={entry.venue}
						className={
							"list-row " +
							(index === 0 ? "rule-top" : "rule-top-soft") +
							(index === SPEAKING.length - 1
								? " rule-bottom"
								: "")
						}
					>
						<div className="list-date">{entry.date}</div>
						<div className="list-text">
							<strong>{entry.venue}</strong>
							{entry.qualifier}
						</div>
					</div>
				))}
			</div>
		</div>
	</Reveal>
);

export default Teaching;
